import defaultState from './defaultState';

export default defaultState();




// WEBPACK FOOTER //
// ./src/store/modules/ski/visitgroup/state.js